import { isEqual } from 'lodash';

import { DEFAULT_GOLF_OPTS } from '../../constants';
import actionTypes from './constants';

const initialState = {
  user: null,
  loginAttempted: false,
  golf: null,
  error: null,
  token: null,
  account: null,
  loading: true,
  navDrawer: [],
  pushToken: null,
  cache: {
    weather: null,
    gameConditions: null,
  },
  weather: null,
  informations: null,
  gameConditions: null,
  activationData: null,
};

function isLoading(state, action) {
  switch (action.type) {
    case actionTypes.LOGOUT:
      return false;
    case actionTypes.CONNECT:
      return true;
    case actionTypes.LOGIN_SUCCESS:
    case actionTypes.SET_USER:
      return state.loading;
    case actionTypes.NO_ACCOUNT:
      return state.golf === null;
    case actionTypes.LOAD_ACCOUNT: {
      const { golf } = state;
      const account = action.payload;
      return account === null || golf === null;
    }
    case actionTypes.NO_GOLF:
      return state.account === null;
    case actionTypes.LOAD_GOLF: {
      const { account } = state;
      const golf = action.payload;
      return account === null || golf === null;
    }
    default:
      return state.loading;
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOGOUT:
      return {
        ...initialState,
        user: null,
        account: null,
        loading: false,
        error: action.payload,
        loginAttempted: false,
      };

    case 'SET_LOGIN_ATTEMPTED':
      if (state.loginAttempted === action.payload) return state;
      return { ...state, loginAttempted: action.payload };

    case actionTypes.CONNECT:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        token: action.payload.token,
        loading: !action.payload.refresh,
      };

    case actionTypes.LOGIN_FAILED:
      return {
        ...state,
        error: action.payload,
      };

    case actionTypes.SET_PUSH_TOKEN:
      if (state.pushToken === action.payload) return state;
      return {
        ...state,
        pushToken: action.payload,
      };

    case actionTypes.SET_USER:
      if (isEqual(state.user, action.payload)) return state;
      return {
        ...state,
        user: action.payload,
      };

    case actionTypes.NO_ACCOUNT:
      return {
        ...state,
        account: false,
        loading: false,
        error: action.payload,
      };

    case actionTypes.LOAD_ACCOUNT: {
      // Conserver playerTypes de l'ancien account si non envoyé
      const { playerTypes = [] } = state.account || {};
      const newAccount = {
        ...action.payload,
        ...(!action.payload.playerTypes && { playerTypes }),
      };
      if (state.account && isEqual(state.account, newAccount)) return state;
      return {
        ...state,
        account: newAccount,
        loading: state.loading && isLoading(state, action),
      };
    }

    case actionTypes.UPDATE_ACCOUNT: {
      const newAccount = state.account ? { ...state.account, ...action.payload } : action.payload;
      if (state.account && isEqual(state.account, newAccount)) return state;
      return {
        ...state,
        account: newAccount,
      };
    }

    case actionTypes.NO_GOLF:
      return {
        ...state,
        golf: false,
        error: action.payload,
        loading: state.loading && isLoading(state, action),
      };

    case actionTypes.LOAD_GOLF: {
      const options = { ...DEFAULT_GOLF_OPTS, ...action.payload.options };
      const newGolf = { ...action.payload, options };
      if (state.golf && isEqual(state.golf, newGolf)) return state;
      return {
        ...state,
        golf: newGolf,
        loading: state.loading && isLoading(state, action),
      };
    }

    case actionTypes.LOAD_ACTIVATION_DATA:
      if (isEqual(state.activationData, action.payload)) return state;
      return {
        ...state,
        activationData: action.payload,
      };

    case actionTypes.GET_GOLF_WEATHER:
      return {
        ...state,
        weather: action.payload,
        cache: {
          ...state.cache,
          weather: Date.now() + 15 * 60 * 1000,
        },
      };

    case actionTypes.GET_GOLF_GAME_CONDITIONS:
      return {
        ...state,
        ...action.payload,
        cache: {
          ...state.cache,
          gameConditions: Date.now() + 15 * 60 * 1000,
        },
      };

    case actionTypes.TOGGLE_PANEL_NAV: {
      let navDrawer;
      const index = state.navDrawer.indexOf(action.payload);
      if (index === -1) {
        navDrawer = [...state.navDrawer, action.payload];
      } else {
        navDrawer = state.navDrawer.filter((el) => el !== action.payload);
      }
      if (isEqual(navDrawer, state.navDrawer)) return state;
      return {
        ...state,
        navDrawer,
      };
    }

    default:
      return state;
  }
};
